import { yup } from '@comptia-sso/core';

export const validationSchema = yup.object().shape({
  newPassword: yup.string().required('Required').isValidPassword(),
});
